let splashProgressEl = document.getElementById("splash-progress-bar");
if (splashProgressEl) {
    splashProgressEl.style.width = "3%";
}

import Vue from "vue";
import {store} from "@store/store";
import {App, utils} from "@3cad/nextcore";
let { measureCode2Label } = utils
import Vuex from "vuex";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import {ServerTable, ClientTable} from "vue-tables-2";
import NextModals from "@dialogs/index";
import VPopover from "vue-js-popover"; // TODO: Remove
import protos from "@store/prototypes"; // TODO: Remove
const _CURRENCIES = require("@assets/json/currencies.json");
const _COUNTRY_CURRENCY = require('@assets/json/country_currency.json');
import VueSlider from "vue-slider-component"

// console.log('prepareVue', App);

if (splashProgressEl) {
    splashProgressEl.style.width = "10%";
}

// components: main library
// TODO: Eliminare o rifare componenti schifosi
import AppSettings from "@app/settings.vue";
import dTable from "@base/dtable.vue";
import dSearch from "@base/dsearch.vue";
import dNav from "@base/dnav.vue";
import dNumber from "@base/dnumber.vue";
import dInput from "@base/dinput.vue";
import dMenu from "@base/dmenu.vue";
import dLabel from "@base/dlabel.vue";
import dDate from "@base/ddate.vue";
import dCoddes from "@base/dcoddes.vue";
import dCod from "@base/dcod.vue";
import dCard from "@base/dcard.vue";
import dUpload from "@base/dupload.vue";
import upload from "@base/_upload.vue";
import uploadImg from "@base/_uploadImg.vue";
import dAuth from "@base/dauth.vue";
import dClose from "@base/dclose.vue";
import dZmissing from "@base/dzmissing";
import dlogin from "@base/_dlogin.vue";
import dmenuItem from "@base/_dmenuItem.vue";
import Datepicker from "@base/_datepicker";
import InputDropdown from "@configurator/comp/inputDropdown";
// TODO: Eliminare o rifare componenti schifosi

// TODO: Eliminare o rifare direttive schifose
// import translate from '@directives/translate';
import focus from "@directives/focus";
import filltoend from "@directives/filltoend";
import mobileDrag from "@directives/mobile-drag";
import Tooltip from "vue-directive-tooltip";

if (splashProgressEl) {
    splashProgressEl.style.width = "18%";
}

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(ServerTable, {}, false, "bootstrap4", "default");
Vue.use(ClientTable, {}, false, "bootstrap4", "default");
Vue.use(require("vue-moment"));
Vue.use(VPopover, {tooltip: true}); // TODO: Remove

if (splashProgressEl) {
    splashProgressEl.style.width = "23%";
}

Vue.prototype.$dauprotos = protos; // TODO: Remove
Vue.prototype.$currencyCodByCountry = (countryCode) => {
    return _COUNTRY_CURRENCY[countryCode] || 'EUR';
}

/** Define dialogs for 3cadnext */
Vue.prototype.$3cadInfo = NextModals;
Vue.prototype.$3cadLoader = NextModals.loader;
Vue.prototype.$3cadComponent = NextModals.component;
Vue.prototype.$3cadFullLoader = NextModals.fullLoader;
Vue.prototype.$3cadAsk = NextModals.ask;
Vue.prototype.$3cadYesNo = NextModals.yesNo;
Vue.prototype.$3cadAssign = NextModals.assignPrj;
Vue.prototype.$3cadPopVariant = NextModals.popVariant;
Vue.prototype.$3cadPopDclass = NextModals.popDclass;
Vue.prototype.$3cadPopDivider = NextModals.popDivider;
Vue.prototype.$3cadLaunchRender = NextModals.launchRender;

// Layedit
Vue.prototype.$isLayedit = window.name === "dCadViewer";

if (splashProgressEl) {
    splashProgressEl.style.width = "29%";
}

// TODO: Eliminare o rifare componenti schifosi
Vue.component("app-settings", AppSettings);
Vue.component("datepicker", Datepicker);
Vue.component("input-dropdown", InputDropdown);
Vue.component("d-zmissing", dZmissing);
Vue.component("d-close", dClose);
Vue.component("d-date", dDate);
Vue.component("d-coddes", dCoddes);
Vue.component("d-cod", dCod);
Vue.component("d-card", dCard);
Vue.component("d-table", dTable);
Vue.component("d-search", dSearch);
Vue.component("d-number", dNumber);
Vue.component("d-input", dInput);
Vue.component("d-nav", dNav);
Vue.component("d-menu", dMenu);
Vue.component("d-label", dLabel);
Vue.component("d-upload", dUpload);
Vue.component("upload", upload);
Vue.component("upload-img", uploadImg);
Vue.component("d-auth", dAuth);
Vue.component("dlogin", dlogin);
Vue.component("dmenuItem", dmenuItem);
Vue.component("d-pageedit", () => import("@base/dpageedit.vue"));
Vue.component("d-json", () => import("@base/djson.vue"));
Vue.component("d-color", () => import("@base/dcolor.vue"));
Vue.component("d-colorpick", () => import("@base/dcolorpick.vue"));
Vue.component("d-chart", () => import("@base/dchart.vue"));
Vue.component("d-cad", () => import("@base/dCad.vue"));
Vue.component("d-cad2d", () => import("@base/dCad2D.vue"));
Vue.component("d-quotes", () => import("@base/dQuotesEng.vue"));
Vue.component("d-caddivider", () => import("@base/dCadDivider.vue"));
Vue.component("erp-combo", () => import("@erpcomp/erpcombo.vue"));
Vue.component("erp-remotecombo", () => import("@erpcomp/erpremotecombo.vue"));

Vue.component("vueSlider", VueSlider);

if (splashProgressEl) {
    splashProgressEl.style.width = "33%";
}

// TODO: Eliminare o rifare filtri schifosi
Vue.filter("date", x => {
    if (x.length > 9) return x.substring(8, 10) + "/" + x.substring(5, 7) + "/" + x.substring(0, 4);
    var x1 = x + "";
    if (x == 0 || x1 == "") return "";
    return x1.substring(6, 8) + "/" + x1.substring(4, 6) + "/" + x1.substring(0, 4);
});
Vue.filter("datetime", x => (x.length > 15 ? x.substring(8, 10) + "/" + x.substring(5, 7) + "/" + x.substring(0, 4) + " " + x.substring(11, 16) : ""));
Vue.filter("number", (x, dec) => {
    if (!x) x = 0;
    if (!dec) dec = 0;
    var rr = x.toLocaleString(undefined, {minimumFractionDigits: dec, maximumFractionDigits: dec});

    return rr;
});
Vue.filter("perc", (value, decimals) => {
    if (!value) value = 0;
    if (!decimals) decimals = 2;
    value = value * 100;
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    value = value + "%";
    return value;
});

Vue.filter("truncate", (value, length) => {
    if (value.length < length) {
        return value;
    }
    length = length - 3;
    return value.substring(0, length) + "...";
});

Vue.directive("focus", focus);
Vue.directive("filltoend", filltoend);
Vue.directive("mobileDrag", mobileDrag);

if (splashProgressEl) {
    splashProgressEl.style.width = "41%";
}

Vue.use(Tooltip, {
    delay: 100,
    placement: "top",
    class: "tooltip-red",
    triggers: ["hover"],
    offset: 0
});

if (splashProgressEl) {
    splashProgressEl.style.width = "49%";
}

/** Define global properties for configurator's components */
Vue.mixin({
    data() {
        return {
            missingImg: require("@assets/img/missing_image.png"),
            currencies: _CURRENCIES
        };
    },
    computed: {
        user() {
            return this.$store.getters["getProfile"];
        },
        guestUser() {
            return this.$store.getters["getGuestProfile"];
        },
        isIntoIframe(){
            return this.$store.getters["getIntoIframe"];
        }
    },
    methods: {
        _trans(...args) {
            // TODO: Can throw errors
            return App.translator.translate(...args);
        },
        _validEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        _unitShortCode(code) {
            return measureCode2Label(code);
        }
    }
});

if (splashProgressEl) {
    splashProgressEl.style.width = "54%";
}



// WEBPACK FOOTER //
// ./src/chunks/prepareVue.js